// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_errors_try_again_button = /** @type {(inputs: {}) => string} */ () => {
	return `Try Again`
};

const id_errors_try_again_button = /** @type {(inputs: {}) => string} */ () => {
	return `Coba Lagi`
};

const ja_errors_try_again_button = /** @type {(inputs: {}) => string} */ () => {
	return `もう一度やり直してください`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_try_again_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_try_again_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_try_again_button", locale)
	if (locale === "en") return en_errors_try_again_button(inputs)
	if (locale === "id") return id_errors_try_again_button(inputs)
	return ja_errors_try_again_button(inputs)
};
export { errors_try_again_button as "errors.try_again_button" }